import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-dpo-permission-help',
  template: `
    <div>
      <span><b>{{'USER_PERMISSIONS.DPO.INTRODUCTION' | translate}}:</b></span>
      <ul class="m-0">
        <li>{{'USER_PERMISSIONS.DPO.CAN_COMMENT_DOCUMENTS' | translate}}</li>
      </ul>
    </div>
  `
})
export class DpoPermissionHelpComponent {
  constructor(public translate: TranslateService) {
  }
}
